var render = function render(){var _vm=this,_c=_vm._self._c;return _c('download-excel',_vm._b({attrs:{"name":_vm.fileName}},'download-excel',_vm.$attrs,false),[_c('v-btn',{staticClass:"me-3",attrs:{"color":"success","small":""}},[_c('v-icon',{staticClass:"me-1",attrs:{"small":""}},[_vm._v(" mdi-file-excel ")]),_vm._v(" "+_vm._s(_vm.$t('shared.exportExcel'))+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }